/*
 * @Author: your name
 * @Date: 2021-01-22 17:02:07
 * @最后修改时间: 2022-04-02 16:00:58
 * @最后编辑: Betway
 * @Description: In User Settings Edit
 * @FilePath: \mrc-base-frontend\src\utils\constant\index.js
 */
import store from "@/store"
//线上模板地址
let public_url = store.state.userData.web_public_url_prefix || "https://assets.essencehr.io"
// 成本中心模板
export const COST_CENTER_URL = `${public_url}/web/ess-admin/assets/ess-cost-center-import-template.xlsx`

// 岗位等级模板
export const JOB_LEVEL_URL = `https://mrcbase.blob.core.windows.net/mrc-template/岗位等级模板.xls`

// 岗位模板
export const POST_URL = `${public_url}/web/ess-admin/assets/ess-job-import-template.xlsx`

// 国际化Label模板
export const INT_URL = `${public_url}/web/ess-admin/assets/ess-multilanguage-import-template.xlsx`

// 用户信息模板
export const USER_INFO_URL = `${public_url}/web/ess-admin/assets/ess-staff-import-template.xlsx`

// 组织机构模板
export const ORG_URL = `${public_url}/web/ess-admin/assets/ess-org-import-template.xlsx`

//  员工等级模板
export const STAFF_LEVEL_URL = `${public_url}/web/ess-admin/assets/ess-staff-grade-template.xlsx`

//  员工类型模板
export const STAFF_TYPE_URL = `${public_url}/web/ess-admin/assets/ess-staff-type-template.xlsx`

//  员工关系模板
export const STAFF_RELATION_URL = `${public_url}/web/ess-admin/assets/ess-correlation-type-template.xlsx`

//  员工关系配置模板
export const STAFF_RELATION_CONFIG_URL = `${public_url}/web/ess-admin/assets/ess-staff-correlation-template.xlsx`

//  员工属性导入模板
export const STAFF_PROPERTY_URL = `${public_url}/web/ess-admin/assets/staff-policy-import-template.xlsx`

//  代理申请配置导入模板
export const ON_BEHALF_APPLICATION_URL = `${public_url}/web/ess-admin/assets/application_on_behalf_template.xlsx`
